<template>
  <div class="content">
    <p class="title-b">{{pageType ? '忘记密码' : '用户注册'}}</p>
    <p class="line-gray"></p>
    <p class="show"><span class="show-red">温馨提示：</span>带&nbsp;&nbsp;<span class="show-red">*</span>&nbsp;&nbsp;的为必填项
    </p>
    <hint-input
      v-if="pageType == 0"
      ref="name"
      name="name"
      label="真实姓名"
      maxlength="4"
      placeholder="请输入您的真实姓名"
      type="text"
      value=""
      required
      verify="name"
      @verifyCallback="verifyCallback"
    ></hint-input>
    <hint-input
      ref="phone"
      name="phone"
      label="手机号(用户名)"
      placeholder="请输入11位手机号码"
      type="number"
      value=""
      required
      verify="tel"
      :cus-verify="phoneCustom"
      @verifyCallback="verifyCallback"
    ></hint-input>
    <hint-input
      ref="code"
      name="code"
      label="验证码"
      placeholder="请输入短信验证码"
      maxlength="6"
      type="code"
      maxTimer="60"
      :value.sync="verifyResObj.code"
      required
      verify="code"
      :cus-verify="codeCustom"
      @sendBtnClick="sendBtnClick"
      @verifyCallback="verifyCallback"
    >
    </hint-input>
    <hint-input
      ref="pwd0"
      name="pwd0"
      :label="pageType ? '新密码': '密码'"
      :placeholder="pageType ? '请输入新密码': '请输入密码'"
      value=""
      type="password"
      required
      verify="pwd0"
      @verifyCallback="verifyCallback"
    ></hint-input>
    <hint-input
      ref="pwd1"
      name="pwd1"
      :label="pageType ? '确认新密码': '确认密码'"
      :placeholder="pageType ? '请确认新密码': '请确认密码'"
      value=""
      type="password"
      required
      verify="pwd1"
      @verifyCallback="verifyCallback"
    ></hint-input>

    <div :class="['registBtn', pageType ? 'confirmBtn' : '']" @click="registerClick">{{pageType ?
      '确认': '注册'}}
    </div>
  </div>
</template>

<script>
  import HintInput from '@/components/HintInput'

  export default {
    name: 'Register',
    data () {
      return {
        // 0为注册页, 1为忘记密码页
        pageType: 0
        , ifTruePhone: false // 是否为正确的手机号
        // 验证结果回调结果集
        , verifyResObj: {
          name: '',
          phone: '',
          code: '',
          pwd0: '',
          pwd1: ''
        },
        // 电话自定义验证
        phoneCustom: function (data, callback) {
          let value = data.value
            , params = {
            phonecode: value
          }

          // 网络验证是否存在相同手机号
          this.$axios({
            method: 'post',
            url: 'UserManager/CheckUser',
            data: params,
          })
            .then(res => {
              // 这时的this为子组件
              let data = res.data
                , that = 'pageType' in this ? this : this.$parent // 检查是谁在调用
              if (data.isError == 'False') {
                if (that.pageType == 0) {
                  callback('')
                } else if (that.pageType == 1) {
                  callback('该用户不存在,请检查输入!')
                }
                // this.$store.commit('setIfPhone', true)
              } else {
                if (that.pageType == 0) {
                  callback('已存在相同手机号用户!')
                } else if (that.pageType == 1) {
                  callback('')
                }
                // this.$store.commit('setIfPhone', false)
              }
            })
            .catch(err => {
              console.log(err)
              callback('验证手机号失败')
            })

          // callback()
        },
        // 验证码自定义验证
        codeCustom: function (data, callback) {
          let value = data.value
            , nowPhone = this.$parent.$refs.phone.val // 当前填写的手机号
            , params = {
            phonenumber: nowPhone
            , phoneyzm: value
          }

          // 如果为空不验证
          if (value == '') {
            return
          }

          // 开始网络验证验证码
          this.$axios({
            url: 'UserManager/CheckPhoneYZM',
            method: 'post',
            data: params
          })
            .then(res => {
              let data = res.data
              console.log(res)
              if (data.isError == 'False') {
                callback('')
              } else {
                callback(data.errorMessage)
              }
            })
            .catch(err => {
              callback('验证验证码失败')
            })
        }
      }
    }
    , props: {
      // 页面类型,0注册, 1修改密码
      type: {
        type: Number
        , default: 0
      }

    }
    , components: {
      HintInput
    }
    , methods: {
      // 记得清空密码仓库
      // 注册点击
      registerClick () {
        // 所有的输入框调用失去焦点事件,以触发验证
        for (let key in this.$refs) {
          this.$refs[key].blur()
        }

        let ifPass = true
        for (let key in this.verifyResObj) {
          // 如果是忘记密码页跳出名字验证
          if (key == 'name' && this.pageType == 1) {
            continue
          }
          if (this.verifyResObj[key] == '') {
            ifPass = false
            this.$refs[key].blur()
          }
        }

        // 如果通过
        if (ifPass && this.pageType == 1) { // 忘记密码
          this.goForget()
        } else if (ifPass && this.pageType == 0) { // 注册
          this.goRegister()
        }
        // console.log(this.$refs)
      }
      // 发送验证码点击事件
      , sendBtnClick (data) {
        console.log(this.$refs)
        let that = this
        // 先触发一下手机的验证规则
        this.$refs.phone.blur()
        if (this.verifyResObj.phone == '') { // 验证不通过,提示
          return
        }

        // 再联网查询一下手机号状态
        let phone = this.$refs.phone.val
        this.phoneCustom({
            value: phone
          }
          , function (text) {
            if (text == '') { // 如果验证通过,开始发送验证码
              // 重置状态
              // this.$store.commit('setIfPhone', false)

              // 开始倒计时回调
              data.cb()
              console.log(that.verifyResObj.phone)
              // return

              let params = {
                phonenumber: that.verifyResObj.phone,
                spantime: 60,
                key: that.$utils.getCodeKey()
              }

              that.$axios({
                method: 'post',
                url: 'UserManager/SendPhoneYZM',
                data: params
              })
                .then(res => {

                })
                .catch(err => {
                })
            }
          })
      },
      // 验证结果回调
      verifyCallback (name, value) {
        // console.log(name, value, this.verifyResObj)
        if (this.verifyResObj[name] != undefined) {
          this.verifyResObj[name] = value
        }
      },

      // 注册方法网络请求
      goRegister () {
        let params = {
          username: this.verifyResObj.name,
          phonecode: this.verifyResObj.phone,
          pwd: this.verifyResObj.pwd0,
          yzm: this.verifyResObj.code,
        }
          , sendData = this.$store.getters.getDialogConfig

        // 设置默认样式
        sendData.type = this.pageType

        this.$axios({
          method: 'post',
          url: 'UserManager/Regest',
          data: params
        })
          .then(res => {
            let data = res.data

            if (data.isError == 'False') {
              this.$store.commit('resetState')
              sendData.ifSuccess = true
              sendData.ifShow = 1

              // 设置全局username用户名
              this.$store.commit('setUserName', this.verifyResObj.phone)
              this.initDefault()
            } else {
              sendData.ifShow = 1
              sendData.ifSuccess = false
              sendData.message = data.errorMessage
            }
            // this.$store.commit('setDialogConfig', sendData)
          })
          .catch(err => {
            sendData.ifSuccess = false
            sendData.message = '网络连接失败'
            // this.$store.commit('setDialogConfig', sendData)
          })
      }
      // 忘记密码方法网络请求
      , goForget () {
        let
          params = {
            phonecode: this.verifyResObj.phone,
            pwd: this.verifyResObj.pwd0,
            yzm: this.verifyResObj.code,
          }
          , sendData = this.$store.getters.getDialogConfig

        // 设置默认样式
        sendData.type = this.pageType
        sendData.username = this.verifyResObj.phone
        sendData.pwd = this.verifyResObj.pwd0

        this.$axios({
          method: 'post',
          url: 'UserManager/ChangePwd',
          data: params
        })
          .then(res => {
            let data = res.data
              , sendData = {}

            if (data.isError == 'False') {
              this.$store.commit('resetState')
              sendData.ifSuccess = true
              sendData.ifShow = 1
            } else {
              sendData.ifShow = 1
              sendData.ifSuccess = false
              sendData.message = data.errorMessage
            }
            // this.$store.commit('setDialogConfig', sendData)
          })
          .catch(err => {
            sendData.ifSuccess = false
            sendData.message = '网络连接失败'
            // this.$store.commit('setDialogConfig', sendData)
          })
      }
      // 初始化方法
      , initDefault () {
        // 初始化电话号
        // this.$store.commit('setIfPhone', false)
      }
    }
    , created () {
      console.log(this.$route.query)
      // 在这里重置下手机号状态
      if (this.$route.query.type == '1') {
        this.pageType = 1
      } else {
        this.pageType = 0
      }
    }
    , watch: {
      'verifyResObj.phone': function (newValue) {
        this.verifyResObj.code = ''
      }
    }
  }
</script>

<style scoped>
  p, div, input {
    overflow: hidden;
    transition: all .3s;
  }

  .title-b {
    font-size: 24px;
    color: #2E2E2E;
    letter-spacing: 0;
    margin: 19px 0 12px 44px !important;
  }

  .title-b:before {
    content: '';
    position: relative;
    display: inline-block;
    font-size: 0;
    width: 6px;
    height: 20px;
    top: 2px;
    left: 0;
    margin-right: 13px;
    background: #04A4FF;
  }

  .line-gray {
    height: 1px;
    background: #EDEDED;
    margin: 0 24px;
  }

  .content {
    width: 100%;
    height: auto;
    min-height: calc(100% - 253px);
    max-width: 1200px;
    box-sizing: border-box;
    margin: 8px auto;
    background: #ffffff;
    overflow: hidden;
  }

  .show {
    padding-left: 270px;
    margin: 62px 0 16px;
    font-size: 13px;
    color: #949494;
    letter-spacing: 0;
  }

  .show-red {
    color: #FF665F;
  }

  .registBtn {
    width: 120px;
    height: 40px;
    margin-top: 64px;
    margin-left: 340px;
    color: #fff;
    line-height: 40px;
    text-align: center;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: 4px;
    background: url("../assets/regist-bg_off.png") no-repeat center;
    cursor: pointer;
  }

  .registBtn:hover {
    background: url("../assets/regist-bg_on.png") no-repeat center;
  }

  .confirmBtn {
    background: url("../assets/ok-bg_off.png") no-repeat center;
  }

  .confirmBtn:hover {
    background: url("../assets/ok-bg_on.png") no-repeat center;
  }
</style>



// WEBPACK FOOTER //
// src/page/Register.vue